import { connect, DispatchProp } from 'react-redux';

import ConnectRepoPage, {
  type ConnectRepoPageProps,
} from 'src/connect/repo-page/connect-repo-page';
import { EntitiesState } from 'src/redux/entities/entities';
import { BucketState } from 'src/types/state';
import { isUuid } from 'src/utils/is-uuid';

// Connect apps are installed into an account, not a workspace. But the
// repository URL contains the workspace ID, not a username. We need to pass
// the username as the principal ID; in order to get that based on the URL
// alone we have to go digging in the entities table. That means the connect
// API call must wait until after the repository section API has returned.
export const getRepositoryOwnerUuid = (
  entities: EntitiesState,
  repositoryFullSlug: string
): string | undefined => {
  const [owner] = repositoryFullSlug.split('/');
  if (isUuid(owner)) {
    return owner;
  }
  const repo = Object.values(entities.repositories).find(
    r => r.full_name === repositoryFullSlug
  );
  if (!repo) {
    return undefined;
  }
  // @ts-ignore Repo is normalized, so owner is *not* a User object
  return repo.owner;
};

const mapStateToProps = (
  state: BucketState,
  ownProps: ConnectRepoPageProps
) => {
  const { repositoryOwner, repositorySlug } = ownProps.match.params;
  const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;
  const principalId = getRepositoryOwnerUuid(
    state.entities,
    repositoryFullSlug
  );
  return {
    principalId,
  };
};

function mergeProps(
  stateProps: { principalId?: string },
  _dispatchProps: DispatchProp,
  ownProps: ConnectRepoPageProps
) {
  const { appKey, moduleKey, repositoryOwner, repositorySlug } =
    ownProps.match.params;

  return {
    ...stateProps,
    ...ownProps,
    appKey,
    moduleKey,
    repositoryOwner,
    repositorySlug,
  };
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, null, mergeProps)(ConnectRepoPage);
